export enum SocialEnum {
  GOOGLE = 'google',
  MICROSOFT = 'microsoft',
  APPLE = 'apple',
  FACEBOOK = 'facebook'
}
